import { Box, Menu, MenuItem } from "@mui/material";
import React, { useContext } from "react";
import { useAuthContext } from "../AuthContextWrapper";

interface Props {
  isPositionAbsolute?: boolean;
}

export const AuthCircle = ({
  isPositionAbsolute = true,
}: Props): JSX.Element => {
  const { user, signOutUser } = useAuthContext()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    handleClose();
    signOutUser();
  };

  return (
    <Box>
      <button
        onMouseEnter={handleOpen}
        style={{
          position: isPositionAbsolute ? "absolute" : "relative",
          right: 0,
          width: 32,
          height: 32,
          borderRadius: "16px",
          border: "none",
          padding: "0 8px",
          background:
            "linear-gradient(106.08deg, #D8D8FF -94.22%, #ECF9FF 108.81%)",
          fontSize: 12,
          lineHeight: "32px",
          cursor: "pointer",
        }}
      >
        {user && user.initials}
      </button>
      <Menu
        id="advisor-menu"
        anchorEl={anchorEl}
        keepMounted
        autoFocus={false}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onMouseLeave={handleClose}
          onClick={handleSignOut}
          sx={{
            width: 120,
            display: "inherit",
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </Box>
  );
};
